import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useRef, useLayoutEffect, useContext } from '@wordpress/element';
import isShallowEqual from '@wordpress/is-shallow-equal';
/**
 * Internal dependencies
 */

import SlotFillContext from './slot-fill-context';
import useSlot from './use-slot';
export default function Slot(_ref) {
  var name = _ref.name,
      _ref$fillProps = _ref.fillProps,
      fillProps = _ref$fillProps === void 0 ? {} : _ref$fillProps,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = _objectWithoutProperties(_ref, ["name", "fillProps", "as"]);

  var registry = useContext(SlotFillContext);
  var ref = useRef();
  var slot = useSlot(name);
  useLayoutEffect(function () {
    registry.registerSlot(name, ref, fillProps);
    return function () {
      registry.unregisterSlot(name, ref);
    }; // We are not including fillProps in the deps because we don't want to
    // unregister and register the slot whenever fillProps change, which would
    // cause the fill to be re-mounted. We are only considering the initial value
    // of fillProps.
  }, [registry.registerSlot, registry.unregisterSlot, name]); // fillProps may be an update that interact with the layout, so
  // we useLayoutEffect

  useLayoutEffect(function () {
    if (slot.fillProps && !isShallowEqual(slot.fillProps, fillProps)) {
      registry.updateSlot(name, ref, fillProps);
    }
  });
  return createElement(Component, _extends({
    ref: ref
  }, props));
}
//# sourceMappingURL=slot.js.map